// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r3DZ","buttons":"styles_buttons__2wy7D"};